<div class="cb-concept-editor">
    <form [formGroup]="form" (ngSubmit)="save()">
        <!-- Term Field -->
        <div class="form-field">
            <label for="term">Term <span class="required">*</span></label>
            <input
                id="term"
                type="text"
                pInputText
                formControlName="term"
                placeholder="e.g., Active Contract"
                [class.p-invalid]="hasError('term')">
            @if (hasError('term')) {
                <small class="p-error">{{ getErrorMessage('term') }}</small>
            }
        </div>

        <!-- Category Field -->
        <div class="form-field">
            <label for="category">Category <span class="required">*</span></label>
            <p-autoComplete
                id="category"
                formControlName="category"
                [suggestions]="filteredCategories"
                (completeMethod)="filterCategories($event)"
                [dropdown]="true"
                placeholder="Select or type a category"
                [forceSelection]="false"
                [class.p-invalid]="hasError('category')">
            </p-autoComplete>
            @if (hasError('category')) {
                <small class="p-error">{{ getErrorMessage('category') }}</small>
            }
        </div>

        <!-- Definition Field -->
        <div class="form-field">
            <label for="definition">Definition <span class="required">*</span></label>
            <textarea
                id="definition"
                pInputTextarea
                formControlName="definition"
                rows="4"
                placeholder="Provide a clear business definition for this concept..."
                [class.p-invalid]="hasError('definition')">
            </textarea>
            @if (hasError('definition')) {
                <small class="p-error">{{ getErrorMessage('definition') }}</small>
            }
            <small class="hint">
                Explain what this term means in the business context. This helps the AI understand user queries.
            </small>
        </div>

        <!-- Actions -->
        <div class="form-actions">
            <p-button
                label="Cancel"
                [text]="true"
                severity="secondary"
                (onClick)="cancel()">
            </p-button>
            <p-button
                [label]="isNew ? 'Create Concept' : 'Save Changes'"
                icon="fa-regular fa-check"
                type="submit"
                [loading]="saving"
                [disabled]="!form.valid || saving">
            </p-button>
        </div>
    </form>
</div>
